import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const NewsIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M5.42 19.84V4.08H18.58V19.84H5.42ZM7.06 18.2H16.94V5.72H7.06V18.2ZM12.58 7.5H15.06V9.34H12.58V7.5ZM9.02 12.8V7.58H10.7V12.8H9.02ZM12.58 11.04H15.06V12.88H12.58V11.04ZM9.02 14.66H14.98V16.34H9.02V14.66Z" />
    </SvgIcon>
  );
});
